import React from "react";
import layoutRegistry from "./layoutRegistry";

const PageSections = ({ sections, animateHero = false }) => {
    if (!Array.isArray(sections) || sections.length === 0) {
        return null;
    }

    return sections.map((section, index) => {
        const layout = section?.layout;
        const fields = section?.fields;
        const Component = layoutRegistry[layout];

        if (!Component || !fields) return null;

        const sectionId = `${layout}-${index}`;

        // Check if this is a hero/banner section
        const isHero = layout === 'hero' || layout === 'about_hero' || layout === 'event_hero' || layout === 'audio_tour_hero';

        // Exclude AOS from social slider section (FrameSliderSection) - it needs to be visible for Slick to initialize
        const isSliderSection = layout === 'social';
        const aosClass = isSliderSection ? '' : (isHero ? 'aos-fade-up aos-hero' : 'aos-fade-up');

        // Add parent classes for specific sections
        const isOfferingsSection = layout === 'offerings';
        const isLookoutSection = layout === 'section_lookout';
        const isInfoSection = layout === 'info_section';
        const isVisitSection = layout === 'visit_section';
        const isAudioGridSection = layout === 'audio_grid';
        const isKnowSection = layout === 'two_column_faq';
        let additionalClass = '';
        if (isOfferingsSection) {
            additionalClass = 'offering-parent';
        } else if (isLookoutSection) {
            additionalClass = 'section-lookout-parent';
        } else if (isInfoSection) {
            additionalClass = 'info-section-parent';
        } else if (isVisitSection) {
            additionalClass = 'visit-section-parent';
        } else if (isAudioGridSection) {
            additionalClass = 'audio-grid-parent';
        } else if (isKnowSection) {
            additionalClass = 'know-section-parent';
        }

        return (
            <div key={sectionId} className={`page-section ${aosClass} ${additionalClass}`.trim()} data-section-index={index}>
                <Component
                    fields={fields}
                    layout={layout}
                    sectionId={sectionId}
                    index={index}
                />
            </div>
        );
    });
};

export default PageSections;

